<template>
  <div id="app">
    <!--img src="./assets/logo.png"-->
    <!--HelloWorld/-->
    <div class="header">
      <span class="far fa-question-circle fa-4x"></span>
    </div>
    <Decision :data="data.decisions[data.active_decision]" :final_page="data.final_page" :hints="hints" v-on:go_to="switchDecision" v-on:go_to_final_page="switchToFinalPage" />
    <div class="footer">
      <div v-if="general_tip" class="general-tip">
        <!--i class="fa fa-info-circle"></i-->
        <img src="static/img/ecomole-o73.svg" alt="EcoMole" height="42px" width="68px">
        <RichText :parts="general_tip" tag="span"/>
      </div>

      <div class="buttons">
        <button v-on:click="goBack" class="large_button" title="One step back"><span class="fa fa-backward"></span></button>
        <button v-on:click="startOver" class="large_button" title="Restart from the very beginning"><span class="fa fa-sync-alt"></span></button>
      </div>

      <h3>History
        <i class="fa fa-eye toggle" v-if="show_history || on_last_page" v-on:click="toggleHistory" :title="eye_hint"></i>
        <i class="fa fa-eye-slash toggle" v-else v-on:click="toggleHistory" :title="eye_hint"></i>
      </h3>
      <table v-if="show_history || on_last_page">
        <tbody>
          <tr v-for="(step, index) in history" :key="index">
            <td><span v-for="(item, index2) in data.decisions[step.from].title" v-if="'text' in item" class="i" :key="index2">{{ item.text }}</span></td>
            <td>{{ step.to_text }}
              <span v-if="Object.keys(step.variables).length > 0">(<span v-for="(value, variable, index) in step.variables" :key="index"><em>{{ variable }}</em>: {{ value }}<span v-if="index != Object.keys(step.variables).length - 1">, </span></span>)</span></td>
          </tr>
        </tbody>
      </table>

      <h3>Obligations
        <i class="fa fa-eye toggle" v-if="show_obligations || on_last_page" v-on:click="toggleObligations" :title="eye_hint"></i>
        <i class="fa fa-eye-slash toggle" v-else v-on:click="toggleObligations" :title="eye_hint"></i>
      </h3>
      <Obligations :history="history" :decisions="data.decisions" v-if="show_obligations || on_last_page"/>
    </div>
  </div>
</template>

<script>
import Decision from './components/Decision'
import RichText from './components/RichText'
import Obligations from './components/Obligations'

export default {
  name: 'App',
  props: ['data'],
  data: function () {
    return {
      history: [],
      show_history: true,
      show_obligations: false
    }
  },
  components: {
    Obligations,
    Decision,
    RichText
  },
  computed: {
    'on_last_page': function () {
      return this.data.active_decision === 'XX'
    },
    'hints': function () {
      if (this.data.extra && this.data.extra.hints) {
        return this.data.extra.hints
      } else {
        return {}
      }
    },
    'eye_hint': function () {
      if (this.data.extra && this.data.extra.hints && this.data.extra.hints.eye) {
        return this.data.extra.hints.eye
      } else {
        return ''
      }
    },
    'general_tip': function () {
      if (this.data.extra && this.data.extra.extra_info && this.data.extra.extra_info.general_tip) {
        return this.data.extra.extra_info.general_tip
      } else {
        return ''
      }
    }
  },
  methods: {
    'switchDecision': function (data) {
      let newDecision = data.option
      this.history.push({
        from: this.data.active_decision,
        to: newDecision.target,
        to_text: newDecision.text,
        variables: data.variables
      })
      this.data.active_decision = newDecision.target
    },
    'switchToFinalPage': function () {
      this.data.active_decision = 'XX'
    },
    'startOver': function () {
      this.data.active_decision = this.data.start_decision
      this.history = []
    },
    'goBack': function () {
      if (this.history.length > 0) {
        if (this.data.active_decision === 'XX') {
          // the step into recapitulation is not recorded in history, so we have to treat it extra
          this.data.active_decision = this.history[this.history.length - 1].to
        } else {
          let last = this.history.pop()
          this.data.active_decision = last['from']
        }
      } else {
        this.data.active_decision = this.data.start_decision
      }
    },
    'toggleObligations': function () {
      this.show_obligations = !this.show_obligations
    },
    'toggleHistory': function () {
      this.show_history = !this.show_history
    }
  }
}
</script>

<style lang="scss">

  body {
    background-color: #eeeeee;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #444444;
    margin-top: 2rem;
    font-size: 16px;

    div.header {
      margin-bottom: 2rem;
      color: #444444;
    }

    div.footer {
      //border-top: solid 1px #999999;
      max-width: 60rem;
      //display: inline-block;
      padding-top: 0.5rem;
      margin: 2rem auto;
      color: #444444;
      text-align: left;

      div.buttons {
        text-align: center;
      }

    }

    div.general-tip {
      padding-bottom: 1.75rem;
      text-align: center;

      img {
        margin-bottom: -10px;
      }
    }

    button.large_button {
      font-size: 200%;
    }

    table {
      margin: 1rem 0;

      td {
        padding: 0.25rem 1rem;
        text-align: left;

        &.i {
          font-style: italic;
        }
      }

    }

    a {
      color: #50af47;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    span.i {
      font-style: italic;
    }

    ul.fa-ul {
      display: inline-block;
      text-align: center;
      margin-top: 0;
      li {
        text-align: left;
      }
      & > li {
        margin-top: 0.5rem;
      }
    }

    .toggle {
      cursor: pointer;
    }

    input[type="text"] {
      border: none;
      border-bottom: solid 1px #777777;
      font-weight: bold;
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue